import { Modal } from "react-bootstrap";
import AssignedUserForm from "../../App/screens/AssignedUserPage/form";

function AssignedUserPopupModal({
    show,
    onHide,
    workspace_id,
    content_group_id,
    participant_user_options,
    assigned_users,
    assigned_users_object,
    closeDropDownPopup,
    onSubmit
}) {
    return(
        <Modal
            show={show}
            onHide={onHide}
            keyboard={true}
            centered
            className="assigned-users-popup__container assigned-users-popup__modal"
        >
            <Modal.Header closeButton>
            <Modal.Title
                className="font-weight-bold"
            >
                Participants
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AssignedUserForm
                    onSubmit={onSubmit}
                    workspace_id={workspace_id}
                    content_group_id={content_group_id}
                    participant_user_options={participant_user_options}
                    assigned_users={assigned_users}
                    assigned_users_object={assigned_users_object}
                    closeDropDownPopup ={closeDropDownPopup}
                />
            </Modal.Body>
        </Modal>

    )
}

export default AssignedUserPopupModal;